import * as React from 'react'
import I18n from '../../../core/i18n'
import { settingsService, userService } from '../../../core/services'
import * as interfaces from '../../../static/interfaces'
import { Panel, Toggle } from '../../atoms'
import SettingsLayout from '../_layouts/settingsLayout'

declare var window: interfaces.IWindow

interface IProps {
  user: any
  active_path: string
}

interface IState {
  user: interfaces.IUser
  email_notification: boolean
  isSubmitEnabled: boolean
  errors: { [key: string]: null | string }
}

export default class Show extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)

    const { user: initialUser } = userService.getUserFromJson(props.user)
    this.state = {
      user: initialUser,
      email_notification: props.email_notification,
      isSubmitEnabled: true,
      errors: {},
    }
  }

  public handleChangeCheck = async event => {
    const data: any = {}
    const updatedParams: any = {}
    updatedParams[event.target.name] = event.target.checked
    data.settings = updatedParams
    const { flush } = await settingsService.updateNotification(data)

    this.setState({ email_notification: !this.state.email_notification })
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
  }

  public render() {
    return (
      <SettingsLayout
        active_path={this.props.active_path}
        user={this.props.user}
        backgroundColor={this.state.user.guest ? 'white' : 'default'}
      >
        <Panel title={I18n.t('settings.set_notification')} noDecoration={true}>
          <Toggle
            label={I18n.t('settings.email_notification')}
            name="email_notification"
            checked={this.state.email_notification}
            onChangeHandler={this.handleChangeCheck}
          />
        </Panel>
      </SettingsLayout>
    )
  }
}
